/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState, useEffect, useRef, memo } from 'react';
import { Dialog, Transition, Menu, Disclosure } from '@headlessui/react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon, BellIcon, BellAlertIcon, CheckCircleIcon, ExclamationCircleIcon, ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'flowbite-react';

import { logout } from '../../app/authSlice';
import Tab from './Tab';
import { IconosMenu } from './IconosMenu.js';
import Notificaciones from './Notificaciones.js';

import Moodle from '../moodle/Moodle.js';
import Cookies from "universal-cookie";
import { fetchApi } from "../tools"; // Consumir api
import WarningModal from '../components-modals/WarningModal.js';
import { classNames } from "../tools/ClassNames";

const dirWebApp = process.env.REACT_APP_DIR_PRO;

const navigation = []; // array para el menú

const userNavigation = [
  { name: 'Actualizar datos', path: dirWebApp + 'actualizar_datos', onClick: null, metodo: false },
  { name: 'Acceso a Moodle', path: '', onClick: '', metodo: true },
  { name: 'Cambio de contraseña', path: dirWebApp + 'cambiopassword', onClick: null, metodo: false },
  { name: 'Cerrar sesión', path: dirWebApp + 'login', onClick: logout(), metodo: false },
];

let runInitialFetch = true;

const rutaLogo = require('../../imagesLayout/Logo-antiguo.png');

// para asignar el menu al array para que lo dibuje
function setNavigation(accessArr) {
  let id = 1;
  accessArr?.forEach(path => {
    if (path.name !== 'Análisis detalle') {
      navigation.push({
        id, name: path.name, href: path.path === '#' ? path.path : `/campus${path.path}`, current: false, access: path.access, icon: path.icono,
        subMenu: path.path === '#' ? path.submen.map(xx => {
          return {
            href: `/campus${xx.path}`, access: xx.access,
            name: xx.name === "Reporte de Morosidad" ? "Reporte de Descuento Reducido" : xx.name === "Generar Factura" ? "Generar Factura C&M" : xx.name, icon: xx.icono
          };
        }) : ''
      });
      id++;
    }
  });
}

const Sidebar = ({ children, user, activeTab, nivelTab }) => {
  const cookies = new Cookies();
  const urlState = useSelector(state => state.url.urlSchoolApi);
  const url = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlSchoolApi") : urlState;

  const { headersAPI: headers } = useSelector(state => state.url); // Headers para enviar al api viene de redux
  const CarnetMoodle = useSelector(state => state.auth.Carnet);
  const [activeSubMenu, setActiveSubMenu] = useState(null); // Estado para el submenú activo
  const [passMoodle, setPassMoodle] = useState('');
  const [carnetMoodle, setCarnetMoodle] = useState('');
  const [showmoodle, setShowMoodle] = useState(false);
  const [showtooltip, setShowtooltip] = useState(true);
  const [showDetalleNoti, setShowDetalleNoti] = useState(false);
  const [detalleNoti, setDetalleNoti] = useState(''); // Detalle de la notificación

  // Manejo de errores
  const [modal, setModal] = useState({
    show: false,
    msg: '',
    ok: false,
  });

  const [activeTabs, setActiveTabs] = useState(Array.isArray(activeTab) ? activeTab : [activeTab]);

  const [notifica, setNotifica] = useState(false);
  const dispatch = useDispatch();

  const Fotov = useSelector(state => state.auth.Fotov);
  const rutaPerfil = (Fotov === '' ? require('../../imagesLayout/perfil-sin-foto.jpg') : Fotov);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const accessArr = useSelector(state => state.auth.paths);

  useEffect(() => {
    if (runInitialFetch) {
      setNavigation(accessArr);
    }
    runInitialFetch = false;
  }, [runInitialFetch]);

  const rawDataNoti = useSelector((state) => state.dashboardAlumno.dataNoti);
  const validarUser = useSelector(state => state.auth.IdEmp);
  const [top, setTop] = useState("");
  const [ancho, setAncho] = useState("");

  const subRefs = useRef([]);
  subRefs.current = [];

  const [tops, setTops] = useState([]);
  const [id, setId] = useState(0);

  useEffect(() => {
    let offsetTops = [];
    subRefs.current.forEach((elemento) => {
      offsetTops.push(elemento.offsetTop);
    });
    setTops([...offsetTops]);
  }, [id]);

  useEffect(() => {
    if (showDetalleNoti) {
      setModal({
        show: true,
        ok: false,
        msg: detalleNoti,
      });
    }else{
      setModal({
        show: false,
        ok: false,
        msg: ""
      });
    }
    runInitialFetch = false;
  }, [detalleNoti, showDetalleNoti]);

  const addToRefs = (el) => {
    if (el && !subRefs.current.includes(el)) {
      subRefs.current.push(el);
    }
  };

  const accesmoodle = async () => {
    const dataMoodle = await fetchApi({
      url: url + '/perfilalumno/passwordmoodle',
      headers,
      content: {
        Carnet: validarUser
      }
    });
    if (dataMoodle.msg[0].Error === '0') {
      setPassMoodle(dataMoodle.msg[0].Mensaje);
      setCarnetMoodle(dataMoodle.msg[0].Username);
      setShowMoodle(true);
    } else {
      setModal({
        msg: dataMoodle.msg[0].Mensaje,
        ok: false,
        show: true
      });
    }
  };

  return (
    <>
      {user !== 'Publico' ? (
        <div>
          {showmoodle && (
            <Moodle
              Carnet={carnetMoodle}
              password={passMoodle}
              setShowMoodle={setShowMoodle}
            />
          )}
          <WarningModal
            open={modal.show ? true : false}
            image={
              showDetalleNoti ? <BellAlertIcon className="h-20 w-20 text-green-500 mx-auto" />
              :( modal.ok
                ? <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
                : <ExclamationCircleIcon className="h-20 w-20 text-secundario mx-auto" />
              )
              
            }
            title = {setShowDetalleNoti ? 'Notificación' : 'Aviso'}
            subtitle={<span>{modal.msg}</span>}
            opacity='bg-opacity-50'
          >
            <div className="mt-5 sm:mt-6">
              <button
                onClick={() => {
                  if (modal.reload) {
                    window.location.reload();
                  }
                  setModal(curr => ({
                    ...curr, show: false, reload: false
                  }));
                  setShowDetalleNoti(false);
                  setDetalleNoti('');
                }}
                type="button"
                className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >
                Entendido
              </button>
            </div>
          </WarningModal>
          <Transition.Root show={sidebarOpen} as={Fragment}>
            <Dialog as="div" className="relative z-40" onClose={setSidebarOpen}>
              <Transition.Child
                as={Fragment}
                enter="transition-opacity ease-linear duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity ease-linear duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
              </Transition.Child>

              <div className="fixed inset-0 z-40 flex">
                <Transition.Child
                  as={Fragment}
                  enter="transition ease-in-out duration-300 transform"
                  enterFrom="-translate-x-full"
                  enterTo="translate-x-0"
                  leave="transition ease-in-out duration-300 transform"
                  leaveFrom="translate-x-0"
                  leaveTo="-translate-x-full"
                >
                  <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-primarioMira">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-in-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in-out duration-300"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div
                        id="sidebar"
                        className="absolute top-0 right-0 -mr-12 pt-2">
                        <button
                          type="button"
                          className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                          onClick={() => setSidebarOpen(false)}
                        >
                          <span className="sr-only">Close sidebar</span>
                          <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                        </button>
                      </div>
                    </Transition.Child>
                    <div className="h-0 flex-1 overflow-y-scroll pt-5 pb-4 ">
                      <div className="flex flex-shrink-0 items-center px-4 pb-4">
                        <img
                          className="mx-auto"
                          src={rutaLogo}
                          alt="Your Company"
                        />
                      </div>
                      {validarUser !== 'PPUBLIC001' && (
                        <div className="flex flex-shrink-0 bg-gray-700 p-4">
                          <Link to="#" className="group block flex-shrink-0">
                            <div className="flex items-center">
                              <div>
                                <img
                                  className="inline-block h-12 w-12 rounded-full"
                                  src={rutaPerfil}
                                  alt=""
                                />
                              </div>
                              <div className="ml-3">
                                <p className="text-base font-medium text-white">{user}</p>
                                <p className="text-sm font-medium text-gray-400 group-hover:text-gray-300">Ver perfil</p>
                              </div>
                            </div>
                          </Link>
                        </div>
                      )}
                      <nav className="mt-5 space-y-1 px-2">
                        {navigation.map((x) => {
                          if (x.access) {
                            x.current = activeTabs.includes(x.name);
                            return (
                              <div key={x.name}>
                                {x.subMenu ? (
                                  <Disclosure>
                                    {({ open }) => (
                                      <>
                                        <Disclosure.Button
                                          className={classNames(
                                            x.current ? `bg-gray-900 text-white` : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                            'w-full group flex items-center px-2 py-2 text-base font-medium rounded-md'
                                          )}
                                        >
                                          <IconosMenu
                                            nameIcono={x.icon}
                                            classes={x.current ? 'text-gray-300 mr-4 flex-shrink-0 h-6 w-6' : 'text-gray-400 group-hover:text-gray-300 mr-4 flex-shrink-0 h-6 w-6'}
                                          />
                                          {x.name}
                                          {open ? (
                                            <ChevronUpIcon className="h-4 w-4 text-orange-500 ml-2" aria-hidden="true" />
                                          ) : (
                                            <ChevronDownIcon className="h-4 w-4 text-orange-500 ml-2" aria-hidden="true" />
                                          )}
                                        </Disclosure.Button>
                                        <Disclosure.Panel className='bg-secundarioMira rounded-lg'>
                                          {x.subMenu.map((y) => {
                                            return y.access ? (
                                              <Link
                                                key={y.name}
                                                to={y.href}
                                                onClick={() => {
                                                  // Si el submenú ya está activo, no hacemos nada
                                                  if (!(activeSubMenu === y.href)) {
                                                    setActiveSubMenu(y.href); // Actualiza el submenú activo al hacer clic
                                                    setActiveTabs([x.name, y.name]); // Actualiza activeTabs para incluir el submenú
                                                  }
                                                }}
                                                className={classNames(
                                                  activeSubMenu === y.href ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                                  'group flex items-center px-2 py-2 text-base font-medium rounded-md'
                                                )}
                                              >
                                                <IconosMenu
                                                  nameIcono={y.icon}
                                                  classes={activeSubMenu === y.href ? 'text-gray-300 mr-4 flex-shrink-0 h-6 w-6' : 'text-gray-400 group-hover:text-gray-300 mr-4 flex-shrink-0 h-6 w-6'}
                                                />
                                                {y.name}
                                              </Link>
                                            ) : null;
                                          })}
                                        </Disclosure.Panel>
                                      </>
                                    )}
                                  </Disclosure>
                                ) : (
                                  <Link
                                    key={x.name}
                                    to={x.href}
                                    onClick={() => {
                                      // Si el menú principal ya está activo, no hacemos nada
                                      if (activeTabs.includes(x.name)) {
                                        console.log("Ya está activo");
                                      } else {
                                        setActiveSubMenu(null); // Resetea el submenú activo si no hay submenú
                                        setActiveTabs([x.name]); // Actualiza activeTabs para incluir solo el menú principal
                                      }
                                    }}
                                    className={classNames(
                                      x.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                      'group flex items-center px-2 py-2 text-base font-medium rounded-md'
                                    )}
                                  >
                                    <IconosMenu
                                      nameIcono={x.icon}
                                      classes={x.current ? 'text-gray-300 mr-4 flex-shrink-0 h-6 w-6' : 'text-gray-400 group-hover:text-gray-300 mr-4 flex-shrink-0 h-6 w-6'}
                                    />
                                    {x.name}
                                  </Link>
                                )}
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </nav>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
                <div className="w-14 flex-shrink-0">{/* Force sidebar to shrink to fit close icon */}</div>
              </div>
            </Dialog>
          </Transition.Root>

          {/* Static sidebar for desktop */}
          <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:flex-col z-30 w-completo mt-16 ">
            <div className="flex min-h-0 flex-1 flex-col ">
              <div
                id="menuItems"
                className="flex flex-1 flex-col overflow-y-scroll overflow-x-hidden pb-4 "
              >
                <div className="lg:hidden flex flex-shrink-0 items-center">
                  <button
                    type="button"
                    className="inline-flex h- w-12 items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none lg:bg-primarioMira"
                    onClick={() => setSidebarOpen(true)}
                  >
                    <span className="sr-only bg-primarioMira ">Open sidebar</span>
                    <Bars3Icon className="h-8 w-8 bg-primarioMira " aria-hidden="true" />
                  </button>
                </div>

                {/* Narrow sidebar */}
                <nav aria-label="Sidebar" className="hidden h-[100%] lg:block lg:flex-shrink-0 lg:bg-transparent">
                  <div className="flex w-16 bg-primarioMira h-[100%] flex-col p-1 ">
                    <style>
                      {
                        `.w-completo{
                        /*width: -webkit-fill-available;*/
                        width: ${ancho}%;
                        background-color:"#212121";
                      }`
                      }
                    </style>
                    {
                      // Renderizar los elementos de navegación
                      navigation.map((x, idx) => (
                        <div
                          key={idx}
                          id={idx}
                          ref={addToRefs}
                          className={"bg-primarioMira"}
                        >
                          <Tab
                            x={x}
                            setAncho={setAncho}
                            activeTab={activeTab}
                            key={idx}
                            id={idx}
                            top={top}
                          />
                        </div>
                      ))
                    }
                  </div>
                </nav>
              </div>
            </div>
          </div>

          <div className="flex flex-1 flex-col">
            <div className="flex bg-gray-700 pl-2 py-2 sticky top-0 z-30">
              <Tooltip content={"Menú"} placement={'right'} animation='duration-1000' trigger='hover'>
                <button
                  type="button"
                  className="inline-flex h-10 w-12 items-center justify-center rounded-md text-white focus:outline-none hover:text-gray-400 transition duration-500 ease hover:bg-primarioMira"
                  onClick={() => setSidebarOpen(true)}
                  onMouseOver={() => setShowtooltip(true)}
                  onMouseOut={() => setShowtooltip(false)}
                >
                  <span className="sr-only">Open sidebar</span>
                  <Bars3Icon className="h-6 w-6 /lg:hidden block" aria-hidden="true" />
                </button>
              </Tooltip>

              {/* Campana de notificaciones */}
              <div className="flex flex-1 justify-end px-6">
                <div className="ml-4 flex items-center lg:ml-6">
                  {validarUser !== 'PPUBLIC001' && (
                    <div className="relative inline-flex w-fit">
                      {rawDataNoti[0]?.SinLeer > 0 && (
                        <div
                          className="absolute bottom-auto left-auto right-0 top-1 z-30 inline-block -translate-y-1/2 translate-x-2/4 rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100 whitespace-nowrap rounded-full bg-rojoMira px-2 py-1 text-center align-baseline text-sm font-semibold leading-none text-white">
                          {rawDataNoti[0]?.SinLeer}
                        </div>
                      )}
                      <Tooltip content={"Notificaciones"} placement={'left'} animation='duration-1000' trigger='hover'>
                        <button
                          onClick={() => setNotifica(!notifica)}
                          type="button"
                          className="rounded-full p-1 text-white focus:outline-none focus:ring-1 focus:ring-white"
                        >
                          <div className='px-2 bg-primarioMira rounded-full p-1'>
                            <span className="sr-only">View notifications</span>
                            {notifica
                              ? <BellIcon className="h-8 w-8" aria-hidden="true" />
                              : <BellAlertIcon className="h-8 w-8" aria-hidden="true" />
                            }
                          </div>
                        </button>
                      </Tooltip>
                    </div>
                  )}
                  {notifica && (
                    <Notificaciones
                      setNotifica={setNotifica}
                      notifica={notifica}
                      dataNoti={rawDataNoti}
                      showDetalleNoti={showDetalleNoti}
                      setShowDetalleNoti={setShowDetalleNoti}
                      setDetalleNoti={setDetalleNoti}
                      detalleNoti={detalleNoti}
                    />
                  )}
                  {/* Profile dropdown */}
                  {validarUser !== 'PPUBLIC001' && (
                    <Menu as="div" className="relative ml-3">
                      <div>
                        <Menu.Button className="flex max-w-xs items-center rounded-full bg-primarioMira text-sm focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2">
                          <span className="sr-only">Open user menu</span>
                          <img
                            className="h-10 w-10 rounded-full"
                            src={rutaPerfil}
                            alt=""
                          />
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-primarioMira py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {userNavigation.map((x) => (
                            <Menu.Item key={x.name}>
                              {!x.metodo ? ({ active }) => (
                                <Link
                                  onClick={x.onClick !== null ? () => dispatch(logout()) : null}
                                  to={x.path}
                                  className={classNames(
                                    active ? 'bg-secundarioMira' : '',
                                    'block px-4 py-2 text-sm text-white z-50'
                                  )}
                                >
                                  {x.name}
                                </Link>
                              ) : CarnetMoodle === '' || CarnetMoodle === undefined || CarnetMoodle === null ? ({ active }) => (
                                <label
                                  onClick={() => accesmoodle()}
                                  className={classNames(
                                    active ? 'bg-secundarioMira cursor-pointer' : '',
                                    'block px-4 py-2 text-sm text-white z-50'
                                  )}>
                                  {x.name}
                                </label>
                              ) : <></>}
                            </Menu.Item>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  )}
                </div>
              </div>
            </div>

            <main className="flex-1">
              <div className='bg-secundarioMira h-full lg:ml-20'>
                {children}
              </div>
            </main>
          </div>
        </div>
      ) : (
        <main className="flex-1">
          <div className='bg-secundarioMira h-full lg:ml-20'>
            {children}
          </div>
        </main>
      )}
    </>
  );
};

export default memo(Sidebar);